module.exports = __webpack_public_path__ + "img/image40.a6b17aea.png";